/**
 *
 * BarChart
 *
 */

import React from "react";
import PropTypes from "prop-types";
// import Chart from "chart.js";
import Chart from "chart.js/auto";

import { updateChartData } from "helpers";

import BarChartWrapper from "./styles/BarChartWrapper";

class BarChart extends React.PureComponent {
  constructor() {
    super();
    this.chartRef = React.createRef();

    this.state = {
      percentBelow: 0,
      percentAbove: 0,
    };
  }

  componentDidMount() {
    const { labels, chartData, userResponseIndex, formData } = this.props;
    const options = {
      plugins: {
        legend: {
              display: false,
        },
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              const itemPercent = Math.round(tooltipItem.formattedValue * 10) / 10;
              const label = `${itemPercent}% of respondents fall into this category`;
              return label;
            },
          }
        }
      },
      barRadius: 6,
      // barRadius: 6,
      scales: {
        // yAxes: [
        //   {
        //     display: false,
        //     gridLines: {
        //       display: false, // Disable grid lines for the y-axis
        //     },
        //     color: "red",
        //   },
        // ],
        // xAxes: [
        //   {
        //     gridLines: {
        //       display: false,
        //     },
        //     ticks: {
        //       fontColor: "#3F3F40",
        //     },
        //   },
        // ],
        y: {
          grid: {
            drawBorder: false,
            display: false
          },
          ticks: {
            display: false
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
          },
        },
      },
    };

    let borderWidthArray = [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ];
    
    borderWidthArray[userResponseIndex] = 2;
    
    let data = {
      labels: labels,
      datasets: [
        {
          barPercentage: 1,
          categoryPercentage: 0.8,
          data: chartData,
          label: "% of respondents of respondents fall into this category",
          borderSkipped: "false",
          backgroundColor: [
            "#D04E42",
            "#FF5C4D",
            "#FF968C",
            "#25AE9D",
            "#65C9BD",
            "#A7EAE2",
            "#6C6C6C",
            "#AEAEAE",
            "#D4D4D4",
          ],
          borderColor: [
            "#09100F",
            "#09100F",
            "#09100F",
            "#09100F",
            "#09100F",
            "#09100F",
            "#09100F",
            "#09100F",
            "#09100F",
          ],
          // borderColor: "#058fe6",
          borderWidth: borderWidthArray,
          borderRadius: 6,
        },
      ],
    };

    data.datasets[0].data.forEach((datum, index) => {
      data.datasets[0].backgroundColor.push(
        `hsla(6, 100%, ${94 - index * 10}%, 1)`
      );
    });
    // chartData.forEach((_, index) => {
    //   if (userResponseIndex === index) {
    //     // borderWidthArray.push(3);
    //     borderWidthArray.push(5);
    //   } else {
    //     borderWidthArray.push(0);
    //   }
    // });

    // Chart.defaults.global.defaultFontColor = "#3F3F40";
    // Chart.defaults.global.defaultFontFamily = "'Poppins', sans-serif";
    Chart.defaults.font.family = "'Poppins', sans-serif";
    Chart.defaults.font.size = 10;
    this.myChart = new Chart(this.chartRef.current, {
      type: "bar",
      options: options,
      data: data,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chartData !== this.props.chartData) {
      const { labels, chartData, userResponseIndex, formData } = this.props;
      updateChartData(this.myChart, labels, chartData, userResponseIndex, formData);
    }
  }

  render() {
    return (
      <BarChartWrapper>
        <canvas ref={this.chartRef} />
      </BarChartWrapper>
    );
  }
}

BarChart.propTypes = {
  chartData: PropTypes.array,
};

export default BarChart;
